import moment from 'moment';
import { get } from 'lodash';
import { Rejections } from '../models/order';

export const WEEKDAY_LABELS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

// Per-user persistence for the day-of-week chart selectors. Keys are namespaced
// by userId + dashboard + chart so selections don't leak between users/charts on
// a shared browser, e.g. `gps.dow.{userId}.admin.line`. Values are stored as a
// JSON array of weekday labels; any parse error or missing/empty value falls
// back to all 7 days (WEEKDAY_LABELS).
export const dowKey = (userId, dashboard, chart) => `gps.dow.${userId}.${dashboard}.${chart}`;

export const loadDays = key => {
  try {
    const raw = key ? localStorage.getItem(key) : null;
    if (!raw) return WEEKDAY_LABELS;
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed) || !parsed.length) return WEEKDAY_LABELS;
    return parsed;
  } catch (e) {
    return WEEKDAY_LABELS;
  }
};

export const saveDays = (key, val) => {
  try {
    if (!key) return;
    localStorage.setItem(key, JSON.stringify(val || []));
  } catch (e) {
    // ignore storage failures (e.g. private mode / quota)
  }
};

export const fmtDate = d => (d ? moment(d).format('L') : '');
export const fmtTick = d => moment(d).format('ddd M/D');

export const truncate = (str, n) => (str && str.length > n ? `${str.slice(0, n)}…` : str || '');

export const computeWeekdayAverages = series => {
  const buckets = WEEKDAY_LABELS.map(day => ({ day, total: 0, count: 0 }));
  (series || []).forEach(row => {
    const m = moment(row.date);
    if (!m.isValid()) return;
    const idx = m.isoWeekday() - 1;
    if (idx < 0 || idx > 6) return;
    const total = (row.delivered || 0) + (row.rejected || 0) + (row.partial || 0);
    buckets[idx].total += total;
    buckets[idx].count += 1;
  });
  return buckets.map(b => ({
    day: b.day,
    average: b.count ? Number((b.total / b.count).toFixed(2)) : 0,
  }));
};

export const getRejectionReason = row => {
  const reason = get(Rejections.find(r => r.value === get(row, 'data.order.rejected')), 'title', '');
  const text = get(row, 'data.order.rejectedText', '') || '';
  return [reason, text].filter(Boolean).join(' — ');
};
